import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import useEffectAsync from "../../../../utilities/hooks/useEffectAsync";
import Lottie from 'react-lottie';
import loginSuccessAnimation from '../../../../animations/loginSuccess.json';
import { reAuthenticateThunk } from "../../../../utilities/authentication/authenticationSlice";
import { goToPage, setFlowType, setPersonalInfo } from "../saleJetBlockSlice";
import { prepareSaleAsync } from '../saleBlockAsyncThunk';
import ThemedLottie from '../../../Shared/ThemedLottie/ThemedLottie';
import { ThemeColorEnum } from '../../../../utilities/theme/ThemeColorEnum';

const LoginSuccessPage = (props) => {

  useEffect(() => {
    props.reAuthenticateThunk('');
  }, []);


  useEffectAsync(async () => {
    if (props._authentication.loginData.isFullAuthenticated) {
      props.setFlowType("existsCustomer");
      const personalInfo = {
        isCustomerExists: true,
        identity: props._authentication.loginData.userDetails.IDNumber,
        subscriberNo: props._authentication.loginData.userDetails.contactNumber,
        firstName: props._authentication.loginData.userDetails.firstName,
        lastName: props._authentication.loginData.userDetails.lastName,
      };
      props.setPersonalInfo(personalInfo);

      const timer = setTimeout(() => { props.prepareSaleAsync() }, 2000);
      return () => clearTimeout(timer);
    }
  }, [props._authentication.loginData.isFullAuthenticated]);

  return (
    <div>
      <div className='sale-page-content'>
        <form noValidate id='sale' onSubmit={handleSubmit}>

          <div className='login-success-page'>
            <div className='animation-wrapper'> 
              {/* <Lottie options={{ animationData: loginSuccessAnimation, loop: false, resizeMode: 'cover' }} height={250} />  */}
              <ThemedLottie animationData={loginSuccessAnimation} color={ThemeColorEnum.PRIMARY} height={250} loop={false} resizeMode="cover" />
            </div>
              <div className='bottom-text'>
                אורזים לך את כל מה  שצריך
              </div>
          </div>

        </form>
      </div>
    </div>
  );

  function handleSubmit(event) {
    event.preventDefault();
  }

};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleJetBlock.saleType,

    //other states
    _authentication: state.authentication,
  };
};

const mapDispatchToProps = {
  reAuthenticateThunk,
  goToPage,
  setFlowType,
  setPersonalInfo,
  prepareSaleAsync
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginSuccessPage);
